export class ApprovalModel {
  public applicationNo: number;
  public updatedUser: string;
  public userRole: string;
  public action: string;
  public remark: string;
  public type: string;
  public process: string;
  public selectedIdArr: number[];
  public stage: string;
}
